export default class InfiniteTriggerService {
  canLoadMoreItems({totalItems, itemsPerPage, currentPage}) {
    return Math.ceil(totalItems / itemsPerPage) > currentPage;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/infinite-trigger/infinite-trigger.service.js